function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import Button from '@airwallex/button';
import OutsideClickHandler from 'react-outside-click-handler';
import { IconChevronDown } from '@airwallex/glyphs';
import DropdownMenu from './index';
import { ButtonContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

var DropdownButton = function DropdownButton(_ref) {
  var children = _ref.children,
      menuRight = _ref.menuRight,
      buttonText = _ref.buttonText,
      hideChevron = _ref.hideChevron,
      smallMenu = _ref.smallMenu,
      iconPosition = _ref.iconPosition,
      secondaryIcon = _ref.secondaryIcon,
      secondaryIconPosition = _ref.secondaryIconPosition,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? false : _ref$responsive,
      controlledState = _ref.controlledState,
      props = _objectWithoutProperties(_ref, ["children", "menuRight", "buttonText", "hideChevron", "smallMenu", "iconPosition", "secondaryIcon", "secondaryIconPosition", "responsive", "controlledState"]);

  var innerState = useState(false);

  var _ref2 = controlledState || innerState,
      _ref3 = _slicedToArray(_ref2, 2),
      show = _ref3[0],
      setShow = _ref3[1];

  var isResponsive = responsive && !smallMenu;
  return ___EmotionJSX(ButtonContainer, {
    responsive: isResponsive
  }, ___EmotionJSX(Button, _extends({
    onClick: function onClick(e) {
      e.preventDefault();
      setShow(function (s) {
        return !s;
      });
      e.stopPropagation();
    },
    icon: hideChevron ? null : IconChevronDown,
    iconPosition: iconPosition,
    secondaryIcon: secondaryIcon,
    secondaryIconPosition: secondaryIconPosition,
    dropdownButtonShowMenu: show,
    responsive: isResponsive,
    "aria-haspopup": true,
    "aria-expanded": show
  }, props), buttonText), show && ___EmotionJSX(OutsideClickHandler, {
    onOutsideClick: function onOutsideClick() {
      return setTimeout(function () {
        return setShow(false);
      });
    }
  }, ___EmotionJSX(DropdownMenu, {
    menuRight: menuRight,
    small: smallMenu,
    responsive: isResponsive
  }, children)));
};

export default DropdownButton;
/*
 onOutsideClick: why need setTimeout?

 Without timeout:
 - First, OutsideClickHandler detects click and sets showMenu to false, but then,
 - Button also detects click and returns showMenu back to true, so the menu stays visible (must click outside Button
   to close the menu, it's annoying)

 Timeout is 1 way to solve the above without stopPropagation/preventDefault etc. With timeout:
 - First, OutsideClickHandler detects click and triggers setTimeout, then,
 - Button also detects click, sets showMenu back to true (which does nothing because the menu is already visible), then,
 - the setTimeout callback kicks in and closes the menu.
 */